import Layout from "../components/layouts/main";
import styles from "./index.module.scss";
import React, { Fragment, ReactElement, useCallback, useEffect, useRef, useState } from "react";
import { titleAdSlide, titleAdVideo } from "../model/dataGlobal";
import { IBaseBox } from "./../model/base";
import classNames from "classnames";
import { chunkArray } from "../util/chunkArray";
import ArticleService from "../services/ArticleService";
import { useRouter } from "next/router";
import utils from "../util/utils";
import { GetServerSideProps } from "next";
import { classDivisionCateMap, getDataFromUrl, getPathAndQuery, mergeByProperty, useWindowSize } from "../util/functionGlobal";
import AdsService from "../services/AdsService";
import { IAds } from "../model/ads";
import dynamic from "next/dynamic";
import PreDynamicState from "../components/PreDynamicState/PreDynamicState";
import NewestPosts from "../components/newestPosts/newestPosts";
import moment from "moment";
import RedirectionService from "../services/RedirectionService";
import ItemPost from "../components/newestPosts/itemPost";

const AdVideo = dynamic(() => import("../components/plugin/adVideo"), {
  ssr: false,
  loading: () => <PreDynamicState height={256} />,
});

const AdSlide = dynamic(() => import("../components/plugin/AdSlide"), {
  ssr: false,
  loading: () => <PreDynamicState height={202} />,
});
const AdSendBanner = dynamic(() => import("../components/plugin/plugin").then((re) => re.AdSendBanner), {
  ssr: false,
  loading: () => <PreDynamicState height={202} />,
});

const DictionaryModule = dynamic(() => import("../components/DictionaryModule/Index").then((re) => re.DictionaryModule), {
  ssr: false,
  loading: () => <PreDynamicState height={202} />,
});

const TopPostComments = dynamic(() => import("../components/topPostComments/topPostComments"), {
  ssr: false,
  loading: () => <PreDynamicState height={238} />,
});
const SildeStyleOne = dynamic(() => import("../components/slideComponent/SildeStyleOne"), {
  ssr: false,
  loading: () => <PreDynamicState height={154} />,
});

const Home = ({
  newestPost,
  count,
  articleSlide,
  categories,
  articleEbook,
  adsYoutube,
  pageSEO,
  articleSlideids = [],
  query,
}: {
  newestPost: IBaseBox[][];
  count: number;
  articleSlide: IBaseBox[];
  categories: any;
  articleEbook: IBaseBox[];
  adsYoutube: IAds;
  pageSEO: number;
  articleSlideids: number[];
  query: string;
}) => {
  console.log(newestPost);
  const router = useRouter();
  const [page, setPage] = useState<number>(Number(getDataFromUrl("page", router.asPath)) || 1);
  const isSearch = router.asPath.includes("query");
  const { width } = useWindowSize();
  const listAds: ReactElement[] = [
    <>
      <div className={classNames(styles["no-padding-es"], "col-12 col-lg-8")}>
        <AdSlide title={titleAdSlide} slides={articleEbook} />
      </div>
      <div className={classNames(styles["no-padding-es"], "col-lg-4 col-12 ")}>
        <DictionaryModule />
      </div>
    </>,
    <>
      <div className={classNames(styles["no-padding-es"], "col-12 col-lg-8")}>
        <AdVideo title={titleAdVideo} link={adsYoutube?.content || "https://www.youtube.com/embed/cvoW2SLfM0M"} />
      </div>
      <div className="col-xl-4 topic-banner d-none d-xl-block">
        <AdSendBanner />
      </div>
    </>,
  ];

  const [isHasMore, setIsHasMore] = useState<boolean>(true);
  const [loadingMore, setLoadingMore] = useState<boolean>(false);
  const [dataMore, setDataMore] = useState<IBaseBox[]>([]);

  useEffect(() => {
    setDataMore([]);
  }, [query]);

  const loadMoreArticle = useCallback(() => {
    setLoadingMore(true);
    fetch(
      !isSearch
        ? `/blog/api/articles_index?limit=6&notIn=${articleSlideids.join(",")}&skip=${30 + (page - 1) * 6}`
        : `/blog/api/articles_search?limit=6&query=${query}&skip=${15 + (page - 1) * 6}`
    )
      .then((response) => response?.json())
      .then((data: IBaseBox[]) => {
        const dataModCategory = data.map((item) => {
          return {
            ...item,
            categories: mergeByProperty(categories, item.category_article_mapping, "id", "category_id"),
          };
        });
        setDataMore((prev) => [...prev, ...dataModCategory]);
        setPage((prev) => prev + 1);
        setLoadingMore(false);
        if (data.length < 6) {
          setIsHasMore(false);
        }
      });
  }, [page, articleSlideids, categories]);

  const initialRandomArticle = useRef(false);
  const [dataToday, setDataToday] = useState<IBaseBox[]>([]);
  const getRandomArticle = useCallback(() => {
    fetch(`/blog/api/get_random`)
      .then((response) => response?.json())
      .then((data) => {
        setDataToday(data.data);
      });
  }, []);

  useEffect(() => {
    if (!initialRandomArticle.current) {
      initialRandomArticle.current = true;
      getRandomArticle();
    }
  }, []);

  return (
    <Layout
      article={null}
      page={pageSEO}
      totalPage={Math.ceil(count / 15)}
      seoTitle={`Blog chia sẻ kinh nghiệm kinh doanh online hiệu quả nhất`}
      seoDescription={`Bạn đang kinh doanh online và muốn tìm cách bán hàng online hiệu quả? Đọc ngay Blog Sapo để cập nhật kiến thức kinh doanh online hiệu quả và cách mở cửa hàng kinh doanh thiết thực nhất`}
      showBanner={true}
    >
      <div id={styles.wrapper} className="main-content">
        <div className="container">
          {isSearch && (
            <h1 className={styles["page-tag"]}>
              Kết quả tìm kiếm cho:
              <strong>{router.query.query || ""}</strong>
            </h1>
          )}
          <div className="row">
            {articleSlide?.length > 0 && !isSearch && page === 1 && (
              <>
                <div className={classNames(styles["no-padding-es"], "col-12 col-lg-8")}>
                  <SildeStyleOne slides={articleSlide} categories={categories} />
                </div>
                {width > 991 && dataToday && dataToday.length > 0 && (
                  <div className="col-lg-4 col-12 d-lg-block d-none">
                    <TopPostComments posts={dataToday} />
                  </div>
                )}
              </>
            )}
            <div className={classNames(styles["newest-posts"], "col-12")}>
              <div className="row">
                {newestPost?.map((posts, index) => {
                  return (
                    <Fragment key={index}>
                      {index < 2 && index > 0 && page === 1 && !isSearch ? listAds[index - 1] : null}
                      {index >= 2 && !isSearch ? (page === 1 ? listAds[1] : listAds[0]) : null}
                      <NewestPosts firstIndex={index === 0} posts={posts} />
                    </Fragment>
                  );
                })}
                {dataMore.map((post) => (
                  <ItemPost key={post.article_id} post={post} firstIndex={false} />
                ))}
              </div>
            </div>
          </div>
          {isHasMore && newestPost.flat().length >= 15 && (
            <div className="d-flex align-items-center justify-content-center">
              <button className={classNames(styles["btn-loadmore"])} onClick={loadMoreArticle} disabled={loadingMore}>
                Xem thêm
                {loadingMore ? (
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                      <path d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"></path>
                    </svg>
                  </span>
                ) : null}
              </button>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default Home;

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { page = 0 } = context.query;
  const { resolvedUrl } = context;
  const query = getDataFromUrl("query", resolvedUrl) ? decodeURIComponent(getDataFromUrl("query", resolvedUrl)) : "";
  const pathAndQuery = getPathAndQuery(context.resolvedUrl);
  const listPath = [process.env.NEXT_PUBLIC_BASE_PATH + pathAndQuery.query, process.env.NEXT_PUBLIC_BASE_PATH + pathAndQuery.path + "/"];
  const redirection = await RedirectionService.getRedirect(listPath);

  if (redirection) {
    if (redirection.target.startsWith("/blog/")) {
      return {
        redirect: {
          destination: redirection.target.replace("/blog", "") + pathAndQuery.query,
          statusCode: 301,
        },
      };
    } else {
      return {
        redirect: {
          permanent: false,
          destination: redirection.target.startsWith("http") ? redirection.target : `https://www.sapo.vn${redirection.target}`,
        },
      };
    }
  }

  const [categories, articleSlide, adsYoutube] = await Promise.all([
    utils.getSharedData(),
    ArticleService.filter({
      status: true,
      limit: 5,
      page: 0,
      after_created_at: moment().subtract(1, "months").startOf("months").toDate(),
      before_created_at: moment().toDate(),
      sort_by: "asc",
      order_by: "created_at",
    }),
    AdsService.getAdsId(161),
  ]);

  const articleSlideids = articleSlide.map((obj) => obj.id);
  let data: IBaseBox[] = [];
  if (query) {
    data = await ArticleService.search({
      query: query,
      limit: 15,
      page: 1,
    });
  } else {
    data = await ArticleService.filter({
      limit: 15,
      page: 1,
      not_in: articleSlideids,
      not_category_ids: [86],
      sort_by: "desc",
      order_by: "published_at",
      status: true,
    });
  }

  const cate = classDivisionCateMap(categories.categories, 26);
  const [count, articleEbook] = await Promise.all([
    query
      ? ArticleService.countWithSearch(query)
      : ArticleService.countArticle({
          title: query,
          status: true,
          not_in: query ? null : articleSlideids,
        }),
    ArticleService.filter({
      category_ids: cate,
      status: true,
      limit: 10,
    }),
  ]);

  const dataModCategory = data.map((item) => {
    return {
      ...item,
      categories: mergeByProperty(categories.categories, item.category_article_mapping, "id", "category_id"),
    };
  });

  const props = JSON.parse(
    JSON.stringify({
      query,
      categories: categories.categories,
      newestPost: chunkArray(dataModCategory, 6),
      articleSlide: articleSlide,
      count,
      articleEbook: articleEbook,
      adsYoutube: adsYoutube,
      pageSEO: page,
      articleSlideids: articleSlideids,
    })
  );

  return {
    props,
  };
};
